(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-about-impact"] && !Shopify.designMode) return;
  try {
    
  const initializeImpactCarousels = (scope = document) => {
    for (const root of scope.querySelectorAll('[data-mb-about-impact]')) {
      if (root.dataset.carouselReady === 'true') continue;
      const track = root.querySelector('[data-impact-track]');
      const controls = root.querySelectorAll('[data-impact-direction]');
      if (!track || controls.length !== 2) continue;

      root.dataset.carouselReady = 'true';
      const step = () => {
        const card = track.querySelector('.mb-about-impact__card');
        const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      };

      for (const control of controls) {
        control.addEventListener('click', () => {
          const direction = Number(control.dataset.impactDirection);
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          let left = track.scrollLeft + direction * step();
          if (direction < 0 && track.scrollLeft <= 1) left = maximum;
          if (direction > 0 && track.scrollLeft >= maximum - 1) left = 0;
          track.scrollTo({ left, behavior: 'smooth' });
        });
      }
    }
  };

  initializeImpactCarousels();
  document.addEventListener('shopify:section:load', (event) => initializeImpactCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mb-home-hero')) {
    class MbHomeHero extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.slides = [...this.querySelectorAll('[data-mb-home-slide]')];
        this.dots = [...this.querySelectorAll('[data-mb-home-dot]')];
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.pointerStartX = null;
        this.onClick = this.handleClick.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.onPointerDown = this.handlePointerDown.bind(this);
        this.onPointerUp = this.handlePointerUp.bind(this);
        this.onPause = this.stopAutoplay.bind(this);
        this.onResume = this.startAutoplay.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('pointerdown', this.onPointerDown, { passive: true });
        this.addEventListener('pointerup', this.onPointerUp, { passive: true });
        this.addEventListener('mouseenter', this.onPause);
        this.addEventListener('mouseleave', this.onResume);
        this.addEventListener('focusin', this.onPause);
        this.addEventListener('focusout', this.onResume);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.show(this.currentIndex);
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('pointerup', this.onPointerUp);
        this.removeEventListener('mouseenter', this.onPause);
        this.removeEventListener('mouseleave', this.onResume);
        this.removeEventListener('focusin', this.onPause);
        this.removeEventListener('focusout', this.onResume);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      show(index) {
        if (!this.slides.length) return;
        const normalized = (index + this.slides.length) % this.slides.length;
        this.currentIndex = normalized;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === normalized;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === normalized;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      handleClick(event) {
        if (this.suppressClick && event.target.closest('a')) {
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
          return;
        }
        const dot = event.target.closest('[data-mb-home-dot]');
        if (dot && this.contains(dot)) {
          this.show(Number(dot.dataset.mbHomeDot));
          this.restartAutoplay();
          return;
        }
        if (event.target.closest('[data-mb-home-previous]')) {
          this.show(this.currentIndex - 1);
          this.restartAutoplay();
        } else if (event.target.closest('[data-mb-home-next]')) {
          this.show(this.currentIndex + 1);
          this.restartAutoplay();
        }
      }

      handleKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.currentIndex - 1);
          this.restartAutoplay();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.currentIndex + 1);
          this.restartAutoplay();
        }
      }

      handlePointerDown(event) {
        if (!event.isPrimary) return;
        this.pointerStartX = event.clientX;
      }

      handlePointerUp(event) {
        if (!event.isPrimary || this.pointerStartX === null) return;
        const delta = event.clientX - this.pointerStartX;
        this.pointerStartX = null;
        if (Math.abs(delta) < 45) return;
        this.suppressClick = true;
        window.setTimeout(() => { this.suppressClick = false; }, 500);
        this.show(this.currentIndex + (delta < 0 ? 1 : -1));
        this.restartAutoplay();
      }

      handleBlockSelect(event) {
        const slide = event.target.closest?.('[data-mb-home-slide]');
        if (!slide || !this.contains(slide)) return;
        this.stopAutoplay();
        this.show(Number(slide.dataset.slideIndex));
      }

      startAutoplay() {
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stopAutoplay();
        const interval = Math.max(3000, Number(this.dataset.interval) || 6000);
        this.autoplayTimer = window.setInterval(() => this.show(this.currentIndex + 1), interval);
      }

      stopAutoplay() {
        if (this.autoplayTimer) window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }
    customElements.define('mb-home-hero', MbHomeHero);
  }

  } catch(e) { console.error(e); }
})();
})();
